/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum BraceletConfirmationAliases {
  BARCODE_COMPONENT = 'barcode-component',
  BUTTON_CONFIRMATION = 'button-confirmation',
  CONTAINER_PANEL_BUTTON_CONFIRMATION = 'container-panel-button-confirmation',
  CONTAINER_PANEL_BUTTON_CONFIRMATION_PADDING = 'container-panel-button-confirmation-padding',
  FIELD_INPUT_PATIENT_CONFIRMATION = 'field-input-patient-confirmation',
  FORM_0 = 'form-0',
  FRAGMENT_INFORMATION_BAR_HEADER = 'fragment-information-bar-header',
  GENERAL_LAYOUT = 'general-layout',
  INPUT_PATIENT_CONFIRMATION = 'input-patient-confirmation',
  LAYOUT_BARCODE = 'layout-barcode',
  PANEL_BARCODE = 'panel-barcode',
  PANEL_BUTTON_CONFIRMATION = 'panel-button-confirmation',
  PANEL_BUTTON_PATIENT_CONFIRMATION = 'panel-button-patient-confirmation',
  PANEL_CONTAINER_INFORMATION_BAR_HEADER = 'panel-container-information-bar-header',
  PANEL_INFORMATION_BAR_HEADER = 'panel-information-bar-header',
}
export { BraceletConfirmationAliases };
